import { masterAxios } from 'api/config'
import { store } from 'store/index'
import { appVersionActions, appVersionSelectors } from 'store/app-version'
import { BUILD_TYPE } from '../config'

export const useAppVersion = () => {
  const state = store.getState()
  const currentPipelineVersion = appVersionSelectors.currentPipelineVersion(state)
  const lastPipelineVersion = appVersionSelectors.lastPipelineVersion(state)

  const getLastPipelineVersion = async (forceRefreshWithNewAvailableVersion?: boolean) => {
    try {
      const { data: newPipelineVersion } = await masterAxios.get(`app-versions/last/${BUILD_TYPE}`)
      console.debug({ newPipelineVersion })
      store.dispatch(appVersionActions.setLastPipelineVersion(newPipelineVersion.version))

      if (forceRefreshWithNewAvailableVersion) {
        if (newPipelineVersion.version > currentPipelineVersion) {
          store.dispatch(appVersionActions.setCurrentPipelineVersion(newPipelineVersion.version))
          reloadWindowAndClearServiceWorker()
        }
      }
    } catch (e) {
      console.error({ getLastPipelineVersionError: e })
    }
  }

  const reloadWindowAndClearServiceWorker = () => {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        store.dispatch(appVersionActions.setCurrentPipelineVersion(lastPipelineVersion))
        return Promise.all(registrations.map((r) => r.unregister()))
      })
      .then(() => window.location.reload())
  }

  return {
    getLastPipelineVersion,
    reloadWindowAndClearServiceWorker,
  }
}
